import React from 'react';
import { Translate } from 'react-redux-i18n';
import Modal from '../../../common/modals/Modal';
import Button from '../../../common/Button';
import logo from '../../../../img/createAccount/envoi.svg';
import { getLinks } from '../../../../network/api/links';

type Props = {
  isOpen: boolean,
  openModal: () => void;
  email: string;
  isCreation: boolean;
};

function AlmostDoneModal(props: Props): JSX.Element {
  return (
    <Modal isOpen={props.isOpen} onClose={props.openModal} className="almost-done-modal">
      <h3>
        <Translate value={`${props.isCreation ? 'END_FORM.CREATION_TITLE' : 'END_FORM.ACTIVATION_TITLE'}`} />
      </h3>
      <div className="information-text">
        <h5><Translate value={`${props.isCreation ? 'END_FORM.CREATION_SUBTITLE' : 'END_FORM.ACTIVATION_SUBTITLE'}`} /></h5>
        <span>
          <Translate className="" value="END_FORM.INSTRUCTION" />
          <span className="email">{props.email}</span>
        </span>
      </div>
      <div>
        <img className="logo" src={logo} alt="logo" />
      </div>
      <div className="information-text">
        <Translate value="END_FORM.TEXT1" />
        <Translate className="" value="END_FORM.TEXT2" />
      </div>
      <div className="button-container">
        <a
          aria-label="Se connecter"
          href={getLinks().connectionLink}
        >
          <Button
            type="primary"
            i18nKey="END_FORM.ACTION"
          />
        </a>
      </div>
    </Modal>
  );
}
export default AlmostDoneModal;
